import { SelectBoardModalProps } from './SelectBoardModal';
import { openModal } from '@core/components/ModalStack';

export async function openSelectBoardModal(props: SelectBoardModalProps) {
  const { SelectBoardModal } = await import('./SelectBoardModal');

  openModal(SelectBoardModal, props);
}
